import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { ALL_CATEGORY_ID } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/All.mobile';
import * as OutcomesView from '~/web-frontend-components/line/Outcomes';
import { matchCategoryID, statisticCategoryID } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/Types.mobile';
import { LOCK_STATE } from '~/web-frontend-core/api/const/base';
import { InlineOutcomes } from './InlineOutcomes';
import { objectEntries } from '~/web-frontend-core/base/lib';
import { sendLogKafka, Events } from '~/web-frontend-components/helpers/kafka';
export const AdditionalTableOutcomes = (props) => {
    const [version, updateVersion] = useState(0);
    const headData = props.outcomes.headTable.getData(props.matchID);
    useEffect(() => {
        const upd = () => { updateVersion(Date.now()); };
        props.outcomes.statistical_categories.subscribe(upd);
        props.outcomes.statistical_tables.subscribe(upd);
        props.outcomes.statistic_types.subscribe(upd);
        props.outcomes.categories.subscribe(upd);
        props.outcomes.tables.subscribe(upd);
        return () => {
            props.outcomes.statistical_categories.unsubscribe(upd);
            props.outcomes.statistical_tables.unsubscribe(upd);
            props.outcomes.statistic_types.unsubscribe(upd);
            props.outcomes.categories.unsubscribe(upd);
            props.outcomes.tables.unsubscribe(upd);
        };
    }, []);
    const categories = props.outcomes.categories;
    const categoriesOrder = categories.order.get(props.matchID);
    const categoriesData = categories.getData(props.matchID);
    const selectedStatType = props.outcomes.statistic_types.getSelected(props.matchID) || { name: matchCategoryID, matchId: props.matchID };
    const [selectedStatTypeID, selectStatType] = useState(selectedStatType.name);
    const [selectedMatchID, selectMatchID] = useState(selectedStatType.matchId);
    /** Выбран статистический матч */
    const isStatisticalMatch = selectedMatchID !== props.matchID;
    /** Выбран тип исходы основного матча */
    const isMatchTypeSelected = selectedStatTypeID === matchCategoryID;
    /** Выбрана тип статистика */
    const isStatisticTypeSelected = selectedStatTypeID === statisticCategoryID;
    /** Фильтр основных исходов матча */
    const matchFilter = categoriesData && (categoriesOrder || [])
        .map((categoryID) => [categoryID, Object.assign({ matchId: props.matchID }, categoriesData[categoryID])]) || [];
    /** Фильтр популярных стат. матчей */
    const getPopularStatFilter = (statMatchID) => {
        const categoriesData2 = props.outcomes.statistical_categories.getData(statMatchID);
        return objectEntries(categoriesData2 || {}).map(([categoryID, category]) => [categoryID, Object.assign({ matchId: statMatchID }, category)]);
    };
    /** Фильтр типа Статистика */
    const notPopularFilter = props.outcomes.statistic_types.getNotPopular(props.matchID);
    const [categoriesFilterData, setCategoriesFilterData] = useState(matchFilter);
    useEffect(() => {
        if (isMatchTypeSelected || categoriesFilterData.length === 0) {
            setCategoriesFilterData(matchFilter);
            return;
        }
        if (isStatisticTypeSelected) {
            setCategoriesFilterData(notPopularFilter);
            return;
        }
        const popularFilter = getPopularStatFilter(selectedMatchID);
        /** Выбраны популярные стат. матчи */
        setCategoriesFilterData(popularFilter);
    }, [version]);
    useEffect(() => {
        if (isMatchTypeSelected) {
            return;
        }
        if (isStatisticTypeSelected) {
            if (notPopularFilter.length !== 0) {
                const [, state] = notPopularFilter.find(([, state]) => state.isSelected) || notPopularFilter[0];
                selectMatchID(state.matchId);
                props.outcomes.statistical_categories.select(state.matchId, [ALL_CATEGORY_ID]);
            }
            return;
        }
        const popularFilter = getPopularStatFilter(selectedMatchID);
        if (popularFilter.length !== 0) {
            const [popularCategoryID, state] = popularFilter.find(([, state]) => state.isSelected) || popularFilter[1];
            props.outcomes.statistical_categories.select(state.matchId, [popularCategoryID]);
        }
    }, [selectedStatTypeID]);
    const onCategoryFavorite = useCallback((categoryIDs, isFavorite) => {
        const categories = isStatisticalMatch ?
            props.outcomes.statistical_categories :
            props.outcomes.categories;
        categories.favorite(selectedMatchID, categoryIDs, isFavorite);
    }, [isStatisticalMatch, selectedMatchID]);
    const onCategoryFilterSelect = useCallback((matchID, categoryIDs, isSelected) => {
        if (isSelected) {
            sendLogKafka(Events.exodusFiltered, { typeId: categoryIDs[0] });
        }
        selectMatchID(matchID);
        if (matchID === props.matchID) {
            categories.select(matchID, categoryIDs, isSelected);
            return;
        }
        if (isStatisticTypeSelected) {
            props.outcomes.statistic_types.select(props.matchID, categoryIDs[0]);
            props.outcomes.statistical_categories.select(matchID, [ALL_CATEGORY_ID]);
            return;
        }
        /** Выбор фильра популярного статистики */
        props.outcomes.statistical_categories.select(matchID, categoryIDs, isSelected);
    }, [props.matchID, isStatisticTypeSelected]);
    const onFoldAllTables = useCallback(() => {
        const tables = isStatisticalMatch ? props.outcomes.statistical_tables : props.outcomes.tables;
        const isAllUnfolded = tables.isAllUnfolded(selectedMatchID);
        tables.fold(selectedMatchID, void 0, isAllUnfolded);
    }, [selectedMatchID, isStatisticalMatch]);
    const onFavoriteTable = useCallback((tableID, isFavorite) => {
        const categories = isStatisticalMatch ?
            props.outcomes.statistical_categories :
            props.outcomes.categories;
        const tables = isStatisticalMatch ? props.outcomes.statistical_tables : props.outcomes.tables;
        tables.favorite(selectedMatchID, [tableID], isFavorite);
        categories.favorite(selectedMatchID);
    }, [selectedMatchID, isStatisticalMatch]);
    const onFoldTable = useCallback((tableID, isFolded) => {
        const tables = isStatisticalMatch ? props.outcomes.statistical_tables : props.outcomes.tables;
        tables.fold(selectedMatchID, [tableID], !isFolded);
    }, [selectedMatchID, isStatisticalMatch]);
    const onStatTypeSelect = useCallback((matchID, categoryID) => {
        props.outcomes.statistic_types.select(props.matchID, categoryID);
        selectMatchID(matchID);
        selectStatType(categoryID);
    }, [props.matchID]);
    const tables = isStatisticalMatch ? props.outcomes.statistical_tables : props.outcomes.tables;
    const isAllUnfolded = tables.isAllUnfolded(selectedMatchID);
    const tablesData = tables.getData(selectedMatchID);
    /** Данные основного матча */
    const matchTableData = props.outcomes.tables.getData(props.matchID);
    if (!tablesData || !headData || !matchTableData) {
        return null;
    }
    return <Fragment>
      <OutcomesView.HeadTable.Body getCoef={(betID) => matchTableData.coefs[betID]} highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} onCoefChoose={props.onCoefChoose} disabled={props.matchData.bl === LOCK_STATE.BLOCKED} mainTable={headData.headTable} className="g-tr"/>
      {(tablesData.additionalOdds && tablesData.additionalOdds.length !== 0 || Object.keys(tablesData.tables).length !== 0) &&
            <tr className={'g-a-tr'}>
            <td colSpan={100}>
               {categoriesData && categoriesOrder &&
                    <OutcomesView.Categories categoriesData={categoriesFilterData} statTypesData={props.outcomes.statistic_types.getPopular(props.matchID)} onStatTypeSelect={onStatTypeSelect} onFoldAllTables={onFoldAllTables} onFavorite={!isStatisticTypeSelected ? onCategoryFavorite : void 0} isAllUnfolded={isAllUnfolded} onSelect={onCategoryFilterSelect} toLocale={props.toLocale} sportID={props.sportID} matchID={props.matchID} width={props.width}/>}

               {tablesData && <OutcomesView.Tables data={tablesData} onFavorite={!isStatisticTypeSelected ? onFavoriteTable : void 0} highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} onCoefChoose={props.onCoefChoose} columnCount={props.columnCount} onFold={onFoldTable}/>}

               {tablesData.additionalOdds && <InlineOutcomes {...props} additionalOdds={tablesData.additionalOdds} disabled={matchTableData.isDisabled} getCoef={(betID) => matchTableData.coefs[betID]} isCoefChoosen={props.isCoefChoosen} onCoefChoose={props.onCoefChoose}/>}
            </td>
         </tr>}
   </Fragment>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/sport/championship/additional/TableOutcomes.jsx